import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-character-sheet',
  templateUrl: './edit-character-sheet.component.html',
  styleUrls: ['./edit-character-sheet.component.css']
})
export class EditCharacterSheetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/character/character-sheet/edit-character-sheet/edit-character-sheet.component.ts